"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _UIAbstractPopup = _interopRequireDefault(require("./UIAbstractPopup"));

var _UIPopoverContent = _interopRequireDefault(require("./UIPopoverContent"));

var _UIPopoverArrow = _interopRequireDefault(require("./UIPopoverArrow"));

var _PlacementConstants = require("./PlacementConstants");

var _EventHandlers = require("../core/EventHandlers");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Placement = require("./utils/Placement");

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _ModalTransitionContext = require("../context/ModalTransitionContext");

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getAnimateOnToggle = function getAnimateOnToggle(animateOnToggle, computedArrowSize) {
  return animateOnToggle != null ? animateOnToggle : computedArrowSize !== 'none';
};

var getPlacement = function getPlacement(placementProp, placementState) {
  return placementState || placementProp;
};

var UIPopover =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIPopover, _PureComponent);

  function UIPopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIPopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIPopover).call(this, props));
    _this.state = {
      closeComplete: true,
      placement: null
    };
    _this.handleWindowClick = _this.handleWindowClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTetherUpdate = _this.handleTetherUpdate.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseComplete = _this.handleCloseComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.reposition = _this.reposition.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIPopover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      if (this.props.open) {
        // Delay binding to ensure that the click that opened the popover is ignored
        this._mountFrame = requestAnimationFrame(function () {
          window.addEventListener('click', _this2.handleWindowClick);

          _this2.startIntersectionObserver();
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // If the placement prop is reset, clear our internal override.
      if (nextProps.placement !== this.props.placement) {
        this.setState({
          placement: null
        });
      } // If a close transition is starting, update the closeComplete state.


      if (!nextProps.open && this.props.open && this.state.closeComplete) {
        this.setState({
          closeComplete: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (open && !prevProps.open) {
        window.addEventListener('click', this.handleWindowClick);
        this.startIntersectionObserver();
      } else if (!open && prevProps.open) {
        window.removeEventListener('click', this.handleWindowClick);
        this.stopIntersectionObserver();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener('click', this.handleWindowClick);
      this.stopIntersectionObserver();
      cancelAnimationFrame(this._mountFrame);
      clearTimeout(this._leaveTransitionTimeout);
    }
  }, {
    key: "startIntersectionObserver",
    value: function startIntersectionObserver() {
      var _this$props = this.props,
          closeOnTargetLeave = _this$props.closeOnTargetLeave,
          onOpenChange = _this$props.onOpenChange; // When closeOnTargetLeave is enabled, we use an IntersectionObserver to close the popover if
      // its target leaves the screen due to scrolling (#3856).

      if (!closeOnTargetLeave) return;
      var _window = window,
          IntersectionObserver = _window.IntersectionObserver;
      if (!IntersectionObserver) return; // No browser support (IE11)

      var targetEl = (0, _reactDom.findDOMNode)(this);
      if (!targetEl) return;
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        var intersectionRatio = entries[0].intersectionRatio;

        if (intersectionRatio <= 0 && onOpenChange) {
          onOpenChange((0, _SyntheticEvent.default)(false));
        }
      });

      this._intersectionObserver.observe(targetEl);
    }
  }, {
    key: "stopIntersectionObserver",
    value: function stopIntersectionObserver() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();

        this._intersectionObserver = null;
      }
    }
  }, {
    key: "handleWindowClick",
    value: function handleWindowClick(evt) {
      var _this$props2 = this.props,
          closeOnOutsideClick = _this$props2.closeOnOutsideClick,
          onOpenChange = _this$props2.onOpenChange,
          shouldCloseOnClick = _this$props2.shouldCloseOnClick,
          target = _this$props2.target;

      if (shouldCloseOnClick) {
        var shouldClose = shouldCloseOnClick(evt);

        if (shouldClose != null) {
          if (shouldClose && onOpenChange) onOpenChange((0, _SyntheticEvent.default)(false));
          return;
        }
      }

      if (!closeOnOutsideClick || !this._isMounted) return;
      var clickTarget = evt.target;
      var tetherTarget = target || (0, _reactDom.findDOMNode)(this._popup);
      var contentEl = (0, _reactDom.findDOMNode)(this._content); // Ignore the click if it's within our Tether target

      if (tetherTarget && tetherTarget.contains(clickTarget)) return; // Ignore the click if it's within our popover container

      if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return; // Otherwise, trigger close

      if (onOpenChange) onOpenChange((0, _SyntheticEvent.default)(false));
    }
  }, {
    key: "handleTetherUpdate",
    value: function handleTetherUpdate(evt) {
      // Adjust our placement state to reflect Tether's response to a constraint
      var _this$props3 = this.props,
          autoPlacement = _this$props3.autoPlacement,
          onChangePlacement = _this$props3.onChangePlacement,
          placementProp = _this$props3.placement;
      var placementState = this.state.placement;
      var oldPlacement = getPlacement(placementProp, placementState);
      var newPlacement = (0, _Placement.computeNewPlacement)(oldPlacement, evt.targetAttachment, autoPlacement);
      if (!newPlacement) return;

      if (this.state.placement !== newPlacement) {
        this.setState({
          placement: newPlacement
        });
        if (onChangePlacement) onChangePlacement({
          newPlacement: newPlacement
        });
      }
    }
  }, {
    key: "handleCloseComplete",
    value: function handleCloseComplete() {
      var onCloseComplete = this.props.onCloseComplete;
      if (onCloseComplete) onCloseComplete();

      if (this._isMounted) {
        this.setState({
          closeComplete: true
        });
      }
    }
  }, {
    key: "reposition",
    value: function reposition() {
      if (this._popup) {
        this._popup.repositionTether();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          addTargetClasses = _this$props4.addTargetClasses,
          animateOnMount = _this$props4.animateOnMount,
          animateOnToggle = _this$props4.animateOnToggle,
          arrowSize = _this$props4.arrowSize,
          autoPlacement = _this$props4.autoPlacement,
          children = _this$props4.children,
          className = _this$props4.className,
          __closeOnOutsideClick = _this$props4.closeOnOutsideClick,
          __closeOnTargetLeave = _this$props4.closeOnTargetLeave,
          onFocusLeave = _this$props4.onFocusLeave,
          __onChangePlacement = _this$props4.onChangePlacement,
          onOpenChange = _this$props4.onOpenChange,
          __onCloseComplete = _this$props4.onCloseComplete,
          open = _this$props4.open,
          pinToConstraint = _this$props4.pinToConstraint,
          pinToOutOfBoundsTarget = _this$props4.pinToOutOfBoundsTarget,
          placementProp = _this$props4.placement,
          __shouldCloseOnClick = _this$props4.shouldCloseOnClick,
          target = _this$props4.target,
          targetAttachment = _this$props4.targetAttachment,
          use = _this$props4.use,
          zIndex = _this$props4.zIndex,
          _bodyElement = _this$props4._bodyElement,
          _distanceAdjustment = _this$props4._distanceAdjustment,
          _insetAdjustment = _this$props4._insetAdjustment,
          _useMutationObserver = _this$props4._useMutationObserver,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["addTargetClasses", "animateOnMount", "animateOnToggle", "arrowSize", "autoPlacement", "children", "className", "closeOnOutsideClick", "closeOnTargetLeave", "onFocusLeave", "onChangePlacement", "onOpenChange", "onCloseComplete", "open", "pinToConstraint", "pinToOutOfBoundsTarget", "placement", "shouldCloseOnClick", "target", "targetAttachment", "use", "zIndex", "_bodyElement", "_distanceAdjustment", "_insetAdjustment", "_useMutationObserver"]);
      var _this$state = this.state,
          closeComplete = _this$state.closeComplete,
          placementState = _this$state.placement;
      return _react.default.createElement(_ModalTransitionContext.ModalTransitionContextConsumer, null, function (_ref) {
        var inModalTransition = _ref.transitioning;
        // `contentOpen` triggers open/close transitions
        var contentOpen = open && !inModalTransition; // `tetherOpen` determines whether the popover is in the DOM

        var tetherOpen = contentOpen || !closeComplete; // Perf: Don't generate props for the tether if we're closed.

        var popupProps = null;

        if (tetherOpen) {
          var computedArrowSize = getArrowSize(arrowSize, use);
          var computedAnimateOnToggle = getAnimateOnToggle(animateOnToggle, computedArrowSize);
          var computedArrowParams = _UIPopoverArrow.default.ARROW_SIZES[computedArrowSize];
          var computedPlacement = getPlacement(placementProp, placementState);
          var renderedContent = tetherOpen ? _react.default.createElement(_UIPopoverContent.default, (0, _extends2.default)({}, rest, {
            animateOnMount: Boolean(animateOnMount && !_this3._isMounted || computedAnimateOnToggle && _this3._isMounted),
            animateOnToggle: computedAnimateOnToggle,
            arrowSize: computedArrowSize,
            className: className,
            "data-component-name": "UIPopover",
            onCloseComplete: _this3.handleCloseComplete,
            open: contentOpen,
            placement: computedPlacement,
            ref: function ref(_ref2) {
              _this3._content = _ref2;
            },
            use: use,
            onOpenChange: onOpenChange
          })) : null;
          popupProps = {
            addTargetClasses: addTargetClasses,
            autoPlacement: autoPlacement,
            bodyElement: _bodyElement,
            center: computedArrowSize !== 'none',
            content: renderedContent,
            distance: computedArrowParams.distance + _distanceAdjustment,
            inset: computedArrowParams.inset + _insetAdjustment,
            onFocusLeave: onFocusLeave,
            onTetherUpdate: _this3.handleTetherUpdate,
            open: tetherOpen,
            pinToConstraint: pinToConstraint,
            pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
            placement: computedPlacement,
            ref: function ref(_ref3) {
              _this3._popup = _ref3;
            },
            target: target,
            targetAttachment: targetAttachment,
            zIndex: zIndex,
            _useMutationObserver: _useMutationObserver
          };
        }

        return _react.default.createElement(_UIAbstractPopup.default, popupProps, children);
      });
    }
  }]);
  return UIPopover;
}(_react.PureComponent);

UIPopover.propTypes = (0, _extends2.default)({}, _UIPopoverContent.default.propTypes, {
  addTargetClasses: _react.PropTypes.bool,
  arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)),
  autoPlacement: _UIAbstractPopup.default.propTypes.autoPlacement,
  children: _react.PropTypes.element,
  closeOnOutsideClick: _react.PropTypes.bool.isRequired,
  closeOnTargetLeave: _react.PropTypes.bool.isRequired,
  onFocusLeave: _react.PropTypes.func,
  onChangePlacement: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  pinToConstraint: _UIAbstractPopup.default.propTypes.pinToConstraint,
  pinToOutOfBoundsTarget: _UIAbstractPopup.default.propTypes.pinToOutOfBoundsTarget,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  shouldCloseOnClick: _react.PropTypes.func,
  target: _domElement.default,
  targetAttachment: _react.PropTypes.string.isRequired,
  zIndex: _react.PropTypes.number.isRequired,
  _distanceAdjustment: _react.PropTypes.number,
  _insetAdjustment: _react.PropTypes.number,
  _bodyElement: _domElement.default,
  _useMutationObserver: _react.PropTypes.bool.isRequired
});
UIPopover.defaultProps = (0, _extends2.default)({}, _UIPopoverContent.default.defaultProps, {
  autoPlacement: true,
  closeOnOutsideClick: true,
  closeOnTargetLeave: false,
  _distanceAdjustment: 0,
  _insetAdjustment: 0,
  pinToConstraint: ['top', 'bottom'],
  pinToOutOfBoundsTarget: false,
  targetAttachment: 'auto',
  zIndex: _UIAbstractPopup.default.defaultProps.zIndex,
  _useMutationObserver: false
});
UIPopover.displayName = 'UIPopover';
var UIControlledPopover = UIPopover;
var _default = UIControlledPopover;
exports.default = _default;
module.exports = exports.default;